<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar tipo de identificación' : 'Nuevo tipo de identificación' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <form class="mod-modal-body" @submit.prevent="handleSubmit">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input id="Clave" v-model="form.Clave" type="text" :disabled="isEdit" required maxlength="50" placeholder="INE">
          </div>
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input id="Nombre" v-model="form.Nombre" type="text" required maxlength="120" placeholder="Identificación oficial">
          </div>
          <div class="mod-field">
            <label for="Orden">Orden</label>
            <input id="Orden" v-model.number="form.Orden" type="number" min="0">
          </div>
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input v-model="form.EsActivo" type="checkbox">
              <span>Activo</span>
            </label>
          </div>
          <div class="mod-field empleado-identificacion-tipo-wide">
            <label for="Descripcion">Descripción</label>
            <input id="Descripcion" v-model="form.Descripcion" type="text" maxlength="255" placeholder="Uso del documento de identificación">
          </div>
        </div>

        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear tipo' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import authService from '@/services/auth';
import { showToast } from '@/shared/utils/toast';
import { createEmpleadoIdentificacionTipo } from './empleadoidentificaciontipo.model';
import empleadoIdentificacionTipoService from './empleadoidentificaciontipo.service';

export default {
  name: 'EmpleadoIdentificacionTipoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createEmpleadoIdentificacionTipo(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) this.form = { ...this.item };
    else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;
      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }
      try {
        const result = await empleadoIdentificacionTipoService.guardar({
          ...this.form,
          Clave: String(this.form.Clave || '').trim().toUpperCase()
        });
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch {
        this.error = 'Error de conexión con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

.empleado-identificacion-tipo-wide {
  grid-column: span 2;
}
</style>

